module.exports = "<p-growl [(value)]=\"msgs\"></p-growl>\r\n<div style=\"color: red\">הכנת פרטי תשלום נכשלה, נא להמתין...</div>"


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/tip-card-change/TripPaymentCardsDetailsVFError/TripPaymentCardsDetailsVFError.component.html
// module id = ../../../../../src/app/tip-card-change/TripPaymentCardsDetailsVFError/TripPaymentCardsDetailsVFError.component.html
// module chunks = main